import dayjs from 'dayjs';

export function normalizeFeeRate(value) {
  const amount = Number(value || 0);
  if (!Number.isFinite(amount) || amount <= 0) {
    return 0;
  }
  return amount;
}

export function formatFeeRate(value) {
  if (value === null || value === undefined || value === '') {
    return '0.0%';
  }

  const amount = normalizeFeeRate(value);
  if (!amount) {
    return '0.0%';
  }

  return `${(amount * 100).toFixed(2)}%`;
}

function normalizedString(value) {
  return value === undefined || value === null ? '' : String(value).trim();
}

export function resolveDiditVerificationUrl(payload = {}) {
  const rawUrl = typeof payload === 'string'
    ? normalizedString(payload)
    : normalizedString(payload?.url);
  const rawToken = typeof payload === 'string'
    ? ''
    : normalizedString(payload?.token);
  const source = rawUrl || rawToken;

  if (!source) {
    return '';
  }

  if (/^https?:\/\//i.test(source)) {
    return source;
  }

  return `https://verify.didit.me/session/${encodeURIComponent(source)}`;
}

export function formatCardTimestamp(timestamp) {
  if (!timestamp) {
    return '';
  }

  const value = Number(timestamp);
  if (!Number.isFinite(value)) {
    return '';
  }

  const date = dayjs(value < 10000000000 ? value * 1000 : value);
  return date.isValid() ? date.format('YYYY-MM-DD HH:mm') : '';
}

export function formatTradeAmount(item = {}) {
  const amount = Number(item.amount || 0);
  const prefix = amount > 0 ? '+' : '';
  return `${prefix}${item.amount || '0'} ${item.symbol || ''}`.trim();
}
